import { render, staticRenderFns } from "./user-group-extension.vue?vue&type=template&id=6454eaba&scoped=true&"
import script from "./user-group-extension.vue?vue&type=script&lang=tsx&"
export * from "./user-group-extension.vue?vue&type=script&lang=tsx&"
import style0 from "./user-group-extension.vue?vue&type=style&index=0&id=6454eaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454eaba",
  null
  
)

export default component.exports